import * as React from 'react';
import { ProfileMenuComp } from './header-profile-menu';

export const HeaderProfileMenu = ({ locale }) => (props) => {
  return <ProfileMenuComp locale={locale}>{props.children}</ProfileMenuComp>;
};
